import { useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import Features from './components/Features';
import Benefits from './components/Benefits';
import PricingComparison from './components/PricingComparison';
import ProductLineup from './components/ProductLineup';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/1af09471f2b5cbef722af36c4531530c/c169a9dfe09670aa2aee641d46da293d.png" 
                alt="スリホ - 業界レンタルプリンター" 
                className="h-12 w-auto"
              />
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <a href="#features" className={`${isScrolled ? 'text-gray-700' : 'text-white'} hover:text-blue-600 transition-colors font-medium whitespace-nowrap`}>サービス特徴</a>
              <a href="#benefits" className={`${isScrolled ? 'text-gray-700' : 'text-white'} hover:text-blue-600 transition-colors font-medium whitespace-nowrap`}>導入メリット</a>
              <a href="#pricing" className={`${isScrolled ? 'text-gray-700' : 'text-white'} hover:text-blue-600 transition-colors font-medium whitespace-nowrap`}>料金プラン</a>
              <a href="#contact" className="bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition-colors font-medium whitespace-nowrap">お問い合わせ</a>
            </div>

            <button 
              className={`md:hidden ${isScrolled ? 'text-gray-700' : 'text-white'} w-10 h-10 flex items-center justify-center`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 py-4 space-y-3">
              <a href="#features" className="block text-gray-700 hover:text-blue-600 py-2 font-medium" onClick={() => setIsMenuOpen(false)}>サービス特徴</a>
              <a href="#benefits" className="block text-gray-700 hover:text-blue-600 py-2 font-medium" onClick={() => setIsMenuOpen(false)}>導入メリット</a>
              <a href="#pricing" className="block text-gray-700 hover:text-blue-600 py-2 font-medium" onClick={() => setIsMenuOpen(false)}>料金プラン</a>
              <a href="#contact" className="block bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 text-center font-medium whitespace-nowrap" onClick={() => setIsMenuOpen(false)}>お問い合わせ</a>
            </div>
          </div>
        )}
      </nav>

      <Hero />
      <Features />
      <Benefits />
      <PricingComparison />
      <ProductLineup />
      <ContactForm />
      <Footer />
    </div>
  );
}
